import { InteractionLayerSizeV2, LayerHandleV2, ShimBackgroundTypeV2 } from '@volkswagen-onehub/layer-manager';
import React from 'react';
import { PortalContext } from '../../../context/PortalContext';
import { Container, ContainerPadding, Breakpoints, styled, CTA } from '@volkswagen-onehub/components-core';
import { Close } from '@volkswagen-onehub/icons-core';
import { ClubSettings } from '../components/clubSettings/clubSettings';
import { GetPersonUser } from '@esportal/portal-service';

import { useTrackingManager } from '../../../tracking/useTrackingManager';

const CTARelativeContainer = styled.div`
	position: relative;
	z-index: 1000;
`;

export const ClubSettingsLayer = ({
	userData,
	setIsClubSettingsVisible,
	isClubSettingsLayerVisible,
	clubSettingsLayerRef,
	setUpdating,
}: {
	userData: GetPersonUser | null;
	setIsClubSettingsVisible: React.Dispatch<React.SetStateAction<boolean>>;
	isClubSettingsLayerVisible: boolean;
	clubSettingsLayerRef: React.RefObject<LayerHandleV2<any>>;
	setUpdating: React.Dispatch<React.SetStateAction<boolean>>;
}): React.ReactElement => {
	const portalContext = React.useContext(PortalContext);
	const { layerManager } = React.useContext(PortalContext);

	const trackingManager = useTrackingManager();

	const handleClose = (useTracking: boolean) => {
		setIsClubSettingsVisible(false);

		if (useTracking) {
			trackingManager.trackClubVWLayerCloseClick('Club Volkswagen settings Layer', {
				contentId: 'Club Volkswagen settings Layer',
			});
		}

		if (clubSettingsLayerRef?.current) {
			clubSettingsLayerRef?.current.close();
			return ((clubSettingsLayerRef.current as any) = null);
		}
		return null;
	};

	const renderClubSettingsLayer = () => {
		return (
			<PortalContext.Provider value={portalContext}>
				<CTARelativeContainer className="cta__relative-container">
					<Container
						wrap={'never'}
						horizontalAlign={'flex-end'}
						verticalAlign={'center'}
						padding={{
							top: {
								[Breakpoints.default]: ContainerPadding.dynamic0130,
								[Breakpoints.b960]: ContainerPadding.dynamic0140,
							},
							right: {
								[Breakpoints.default]: ContainerPadding.grid001,
								[Breakpoints.b960]: ContainerPadding.dynamic0100,
								[Breakpoints.b1280]: ContainerPadding.dynamic0140,
							},
							bottom: ContainerPadding.dynamic0050,
						}}
					>
						<CTA
							tag="button"
							emphasis="tertiary"
							onClick={() => handleClose(true)}
							aria-label="closePopUp"
							icon={<Close variant="default" aria-hidden />}
						/>
					</Container>
				</CTARelativeContainer>
				<ClubSettings userData={userData} handleClose={handleClose} setUpdating={setUpdating} />
			</PortalContext.Provider>
		);
	};

	const renderInteractionLayer = (): any => {
		if (!clubSettingsLayerRef.current && isClubSettingsLayerVisible) {
			const layer = layerManager.openInteractionLayer(
				renderClubSettingsLayer,
				{},
				{
					size: InteractionLayerSizeV2.B,
					shimBackgroundType: ShimBackgroundTypeV2.OPAQUE,
				},
			);
			(clubSettingsLayerRef.current as any) = layer;
		}
		return null;
	};

	return <>{clubSettingsLayerRef && renderInteractionLayer()}</>;
};
